import { FieldRenderProps, useField, useFormState } from 'react-final-form';
import { ImageField } from '../../../../services/api/upload-vehicle';
import { ImagePlaceholderIcon } from '../../../CreateVehicle/icons/ImagePlaceholder';

import { useRemoveImage } from 'pages/ListerVehicleUploadV2/hooks/useRemoveImage';
import { useBackgroundImage } from 'pages/ListerVehicleUploadV2/hooks/useBackgroundImage';
import { CircularProgress } from '@material-ui/core';
import * as S from './ui';
import { BinIcon, typeToIcon, typeToLabel } from './constants';
import { useRef } from 'react';
import { parseFile } from 'utils/file';
import { resizeV2 } from 'utils/image';

export const NoAutoSavePhoto = ({ input, meta }: FieldRenderProps<ImageField>) => {
  const imageUrl = useBackgroundImage({
    localUrl: input.value.local_url,
    serverUrl: input.value.url,
    onServerLoaded: () => {
      if (input.value.local_url) {
        URL.revokeObjectURL(input.value.local_url);
        input.onChange({ ...(input.value || {}), local_url: '' });
      }
    }
  });

  const isPlaceholder = !imageUrl;

  const type = input.value.type;

  const handleRemove = (e: any) => {
    e?.stopPropagation();
    input.onChange({
      ...input.value,
      url: '',
      url_thumb: '',
      local_url: '',
      file: null
    });
  };

  const handleFileChange: React.ChangeEventHandler<HTMLInputElement> = async event => {
    event.preventDefault();
    const file = event.target.files?.[0];
    if (!file) return;
    const parsedFile = await parseFile(file);
    const resized = await resizeV2(parsedFile, { width: 1600, height: 1200 }, 'jpeg', 1);
    input.onChange({
      ...input.value,
      file: resized,
      local_url: URL.createObjectURL(resized)
    });
  };

  const inputRef = useRef<HTMLInputElement>(null);
  const openFileInput = () => inputRef.current?.click();

  const { submitError } = useFormState();
  const hasError = submitError && !input.value.url && !input.value.file;

  return (
    <S.FieldContainer hasError={hasError}>
      <input
        onChange={handleFileChange}
        ref={inputRef}
        type="file"
        accept=".jpg,.jpeg,.png,.webp,.heic"
        name={`${input.name}_file`}
        style={{ display: 'none' }}
      />
      <S.Image
        hasError={hasError}
        onClick={openFileInput}
        size={'md'}
        imageUrl={imageUrl}
        isPlaceholder={isPlaceholder}
      >
        <S.TopImageRow>
          {!isPlaceholder && (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={handleRemove}>
              <BinIcon />
            </div>
          )}
          {/* <NotesIconComponent disabled={isUploading} fieldName={input.name} /> */}
        </S.TopImageRow>
        {isPlaceholder && (
          <S.PlaceholderWrapper>
            {type != null ? typeToIcon[type] : <ImagePlaceholderIcon />}
            {type != null ? <S.PlaceholderLabel>{typeToLabel[type]}</S.PlaceholderLabel> : ''}
          </S.PlaceholderWrapper>
        )}
        {input.value.label && (
          <S.Label displaySize={'md'}>
            <span>{input.value.label}</span>
          </S.Label>
        )}
      </S.Image>
    </S.FieldContainer>
  );
};
